import { Link } from "react-router-dom";
import { CONTACT, NAV_LINKS } from "../data/site";
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, MessageCircle } from "lucide-react";

export function Footer() {
  return (
    <footer className="relative bg-emerald-dark text-cream grain overflow-hidden" data-testid="footer">
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 lg:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="inline-flex bg-white rounded-2xl p-4 shadow-xl">
              <img src={CONTACT.logo} alt="Kerala Holidays Connect" className="h-28 w-auto object-contain" />
            </div>
            <p className="text-gold-light mt-6 italic font-serif text-xl">{CONTACT.tagline}</p>
            <p className="text-cream/60 mt-6 max-w-sm leading-relaxed">Premium Mumbai to Kerala tour packages — comfortable hotels, trusted drivers and personalised service across God's Own Country.</p>
            <a href={CONTACT.website} className="inline-block mt-4 text-gold-light hover-underline text-sm">{CONTACT.website}</a>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-gold mb-5">Explore</p>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.to}><Link to={l.to} className="text-cream/70 hover:text-cream transition-colors text-sm" data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-gold mb-5">Get in Touch</p>
            <ul className="space-y-4 text-sm">
              <li><a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-cream/80 hover:text-cream" data-testid="footer-phone"><Phone className="w-4 h-4 text-gold-light" /> {CONTACT.phone}</a></li>
              <li><a href={`https://wa.me/${CONTACT.whatsapp}`} className="flex items-center gap-3 text-cream/80 hover:text-cream" data-testid="footer-whatsapp"><MessageCircle className="w-4 h-4 text-gold-light" /> WhatsApp Us</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-cream/80 hover:text-cream" data-testid="footer-email"><Mail className="w-4 h-4 text-gold-light" /> {CONTACT.email}</a></li>
              <li className="flex items-start gap-3 text-cream/80"><MapPin className="w-4 h-4 text-gold-light mt-0.5" /> {CONTACT.address}</li>
            </ul>
            <div className="flex gap-3 mt-6">
              {[[Facebook, CONTACT.social.facebook, "facebook"], [Instagram, CONTACT.social.instagram, "instagram"], [Youtube, CONTACT.social.youtube, "youtube"]].map(([Icon, href, key]) => (
                <a key={key} href={href} target="_blank" rel="noreferrer" data-testid={`footer-social-${key}`} className="w-10 h-10 border border-cream/20 flex items-center justify-center hover:bg-gold hover:border-gold transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-cream/10 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-cream/40">
          <p>© {new Date().getFullYear()} Kerala Holidays Connect. All rights reserved.</p>
          <Link to="/admin" className="hover:text-cream/70" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
